import { render, staticRenderFns } from "./AddAcceptedType.vue?vue&type=template&id=19274277&scoped=true&"
import script from "./AddAcceptedType.vue?vue&type=script&lang=js&"
export * from "./AddAcceptedType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19274277",
  null
  
)

export default component.exports